import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { CheckoutRequiredData, WompyPaymentMethod } from '@interfaces/shared';
import { resolveWompyPublicKey } from '@utils/wompy-public-key.util';
import { CheckoutCallbackResponse } from '@interfaces/shared/checkout-response.interface';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const WidgetCheckout: any;

@Injectable({
  providedIn: 'root'
})
export class WompyCheckoutService {
  constructor(
    public router: Router
  ) { }

  public create({
    currency,
    price,
    paymentRef,
    amountInCents,
    signatureIntegrity,
    redirectUrl,
    publicKey,
    paymentMethod,
    customerEmail,
    customerFullName,
  }: CheckoutRequiredData): void {
    const method: WompyPaymentMethod = paymentMethod || 'card';
    const checkout = new WidgetCheckout({
      currency,
      amountInCents: amountInCents ?? this.toCents(price ?? 0),
      reference: paymentRef,
      publicKey: publicKey || resolveWompyPublicKey(method),
      redirectUrl: redirectUrl || environment.checkout.wompiResponse || `${window.location.origin}/pago/respuesta`,
      ...(signatureIntegrity ? { signature: { integrity: signatureIntegrity } } : {}),
      ...(customerEmail ? { customerEmail } : {}),
      ...((customerEmail || customerFullName)
        ? {
            customerData: {
              ...(customerFullName ? { fullName: customerFullName } : {}),
              ...(customerEmail ? { email: customerEmail } : {}),
            },
          }
        : {}),
    });
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const THIS = this;
    checkout.open(function (result: CheckoutCallbackResponse) {
      const { id } = result.transaction;
      THIS.router.navigate(['/pago/respuesta'], {
        queryParams: {
          id: id
        },
        state: { ...result }
      });
    });
  }

  private toCents(price: number): number {
    return Math.round(price * 100);
  }
}
